import { createAction, createPayloadAction, createRequestActionCreators, RequestAction } from 'helpers/actionsHelpers'
import { PayloadAction, SimpleAction } from 'interfaces/action'
import { Member } from 'interfaces/member'

export const FINISH_ONBOARDING = 'FINISH_ONBOARDING' as const
type FinishOnboarding = RequestAction<typeof FINISH_ONBOARDING, {}, Member>
export const finishOnboardingActionCreator = createRequestActionCreators<
  typeof FINISH_ONBOARDING, {}, Member
>(FINISH_ONBOARDING)

export const CLOSE_ONBOARDING = 'CLOSE_ONBOARDING' as const
type CloseOnboarding = SimpleAction<typeof CLOSE_ONBOARDING>
export const closeOnboardingActionCreator = createAction(CLOSE_ONBOARDING)

export const CHECK_EMAIL_EXISTENCE = 'CHECK_EMAIL_EXISTENCE' as const
type CheckEmailExistence = PayloadAction<typeof CHECK_EMAIL_EXISTENCE, { email: string }>
export const checkEmailExistenceActionCreator = (email: string): CheckEmailExistence =>
  createPayloadAction(CHECK_EMAIL_EXISTENCE, { email })

type Action =
  | FinishOnboarding
  | CloseOnboarding
  | CheckEmailExistence

export default Action
